import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  id: "nav-menu-container"
};
const _hoisted_2 = {
  class: "nav-item"
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/Object.assign({
  name: 'NavMenu'
}, {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();

    // 导航栏列表
    const navList = ref([]);
    // 路由数据源
    const menuSourceList = ref([...router.options.routes.filter(route => route.name === 'common')[0].children.filter(item => item.name !== 'detail' && !item.redirect)]);
    // 格式化
    menuSourceList.value.forEach(item => {
      navList.value.push({
        path: item.path,
        title: item.meta.title
      });
    });
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": _unref(route).path,
        mode: "horizontal",
        router: "",
        "unique-opened": "",
        ellipsis: false,
        class: "menu-box",
        "active-text-color": "#fff",
        "background-color": "transparent",
        style: {
          "border": "0"
        },
        "text-color": "#fff"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, nav => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: nav.path,
            index: nav.path
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(nav.title), 1)]),
            _: 2
          }, 1032, ["index"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active"])]);
    };
  }
});